export default __webpack_public_path__ + "static/media/mechanic.78c2b52e.svg";